import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdCloud,
  MdImage,
  MdMenu,
  MdOutlineShoppingCart,
  MdPerson,
  MdPersonOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Menu.css";
import Spinner from "../components/Spinner";
import { useNavigate } from "react-router";
import { isEmpty } from "../functions/isEmpty";

export default function Menu({ isMobile, user, setUser }) {
  const [isLoading, setIsLoading] = useState(false);
  let navigate = useNavigate();

  const destroySession = () => {
    localStorage.removeItem("@pcpilot_user");
    setUser(null);
  };

  const doNothing = () => {
    navigate("/edit");
  };

  useEffect(() => {
    if (isEmpty(user)) {
      navigate("/login");
    }
  }, [user]);

  return (
    <div className="menu">
      <div className="menu_topnav">
        <div className="menu_topnav_back" onClick={() => navigate(-1)}>
          <ArrowBack /> Menu
        </div>
      </div>
      <div className="menu_list">
        <div
          className="menu_list_item"
          onClick={() => (user ? navigate("/edit") : doNothing())}>
          Accountdaten{" | " + user?.username}
        </div>
        <div className="menu_list_item" onClick={() => destroySession()}>
          Logout
        </div>
      </div>
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const ImgIcon = styled(MdImage)`
  font-size: 25px;
  color: #474747;
`;

const CloudIcon = styled(MdCloud)`
  font-size: 18px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 18px;
  color: #474747;
  margin-bottom: -3px;
`;
